/* Consumer PDP — JS-driven sticky gallery */
(function () {
  if (window.innerWidth < 990) return;

  var gallery = document.querySelector('.product__outer--thumbs-aside .product__main');
  var outer = document.querySelector('.product__outer--thumbs-aside');
  if (!gallery || !outer) return;

  // Outer needs position:relative so position:absolute (bottom state) works correctly
  outer.style.position = 'relative';

  // Move pagination out of the overflow:hidden swiper chain so it's visible.
  // Becomes a direct child of .product__main (flex column) — sits below media.
  var paginationWrapper = gallery.querySelector('.product__pagination-wrapper');
  if (paginationWrapper) {
    gallery.appendChild(paginationWrapper);
  }

  var header = document.querySelector('.shopify-section-header');
  var headerH = header ? header.offsetHeight : 60;
  var galleryW = gallery.offsetWidth;
  var galleryH = window.innerHeight - headerH;

  // Spacer to prevent layout jump — order:0 to sit in gallery's flex slot (left side)
  var spacer = document.createElement('div');
  spacer.className = 'product__main-spacer';
  spacer.style.order = '0';
  spacer.style.width = galleryW + 'px';
  spacer.style.height = '0px';
  spacer.style.flexShrink = '0';
  spacer.style.display = 'none';
  gallery.after(spacer);

  var state = 'normal'; // normal | fixed | bottom
  var galleryLeft = 0; // captured left offset when transitioning to fixed

  function update() {
    // Never apply sticky on mobile — force normal flow and bail
    if (window.innerWidth < 990) {
      if (state !== 'normal') {
        state = 'normal';
        gallery.style.position = '';
        gallery.style.top = '';
        gallery.style.left = '';
        gallery.style.bottom = '';
        gallery.style.width = '';
        gallery.style.height = '';
        gallery.style.zIndex = '';
        gallery.classList.remove('is-stuck');
        spacer.style.display = 'none';
      }
      return;
    }

    var outerRect = outer.getBoundingClientRect();
    var outerTop = outerRect.top;
    var outerBottom = outerRect.bottom;

    if (outerTop >= headerH) {
      // Haven't scrolled past — gallery in normal flow
      if (state !== 'normal') {
        state = 'normal';
        gallery.style.position = '';
        gallery.style.top = '';
        gallery.style.left = '';
        gallery.style.bottom = '';
        gallery.style.width = '';
        gallery.style.height = '';
        gallery.style.zIndex = '';
        gallery.classList.remove('is-stuck');
        spacer.style.display = 'none';
      }
    } else if (outerBottom > headerH + galleryH) {
      // Scrolled past top, outer still has room below — fix gallery in viewport
      if (state !== 'fixed') {
        state = 'fixed';
        // Always capture fresh dimensions when transitioning to fixed
        galleryW = gallery.offsetWidth;
        galleryLeft = gallery.getBoundingClientRect().left;
        gallery.style.position = 'fixed';
        gallery.style.top = headerH + 'px';
        gallery.style.left = galleryLeft + 'px';
        gallery.style.bottom = '';
        gallery.style.width = galleryW + 'px';
        gallery.style.height = galleryH + 'px';
        gallery.style.zIndex = '5';
        gallery.classList.add('is-stuck');
        spacer.style.width = galleryW + 'px';
        spacer.style.height = galleryH + 'px';
        spacer.style.display = 'block';
      }
    } else {
      // Outer ending — pin gallery to bottom of outer, then scroll away with it
      if (state !== 'bottom') {
        state = 'bottom';
        // left offset relative to outer (absolute positioning parent)
        var outerLeft = outer.getBoundingClientRect().left;
        gallery.style.position = 'absolute';
        gallery.style.top = 'auto';
        gallery.style.left = (galleryLeft - outerLeft) + 'px';
        gallery.style.bottom = '0';
        gallery.style.width = galleryW + 'px';
        gallery.style.height = galleryH + 'px';
        gallery.style.zIndex = '5';
        gallery.classList.add('is-stuck');
        spacer.style.display = 'block';
      }
    }
  }

  window.addEventListener('scroll', function () {
    requestAnimationFrame(update);
  }, { passive: true });

  window.addEventListener('resize', function () {
    headerH = header ? header.offsetHeight : 60;
    galleryH = window.innerHeight - headerH;

    // Always recalculate dimensions on resize.
    // If currently fixed/bottom, temporarily reset to normal flow so we can
    // measure the natural width and left position, then re-apply sticky state.
    if (state !== 'normal') {
      var prevState = state;
      // Pull gallery back into flow momentarily
      gallery.style.position = 'relative';
      gallery.style.top = '';
      gallery.style.left = '';
      gallery.style.bottom = '';
      gallery.style.width = '';
      gallery.style.height = '';
      spacer.style.display = 'none';

      // Measure natural dimensions
      galleryW = gallery.offsetWidth;
      galleryLeft = gallery.getBoundingClientRect().left;

      // Restore sticky immediately — reset state so update() re-applies styles
      state = 'normal';
      update();
    } else {
      galleryW = gallery.offsetWidth;
      galleryLeft = gallery.getBoundingClientRect().left;
      update();
    }
  });

  // Initial check
  update();
})();

/* -----------------------------------------------------------------------
   Inline variant controls + condition selector + hidden tier support

   Three patches applied to <variant-radios>:

   1. Move .product-parameters--condition inside variant-radios (cosmetic grouping)
   2. Patch updateOptions() so condition fieldsets never count as variant options,
      AND hidden fieldsets (e.g. legacy Rental Length with style="display:none")
      are auto-aligned to produce an available variant for the visible selections.
   3. Patch updateVariantStatuses() to treat hidden tiers as wildcards — they don't
      constrain downstream availability, so Size/Color stay clickable regardless
      of which hidden Rental Length value happens to be checked.

   Why: without (3), picking a Size that doesn't have a matching variant at the
   currently-checked hidden Rental Length marks Size as `.disabled`, and the
   base CSS applies `pointer-events: none` to disabled labels — rendering the
   variant radio permanently unclickable after one variant-image switch.
----------------------------------------------------------------------- */
(function () {
  var infoContainer = document.querySelector('.product__outer--thumbs-aside .product__info-container');
  if (!infoContainer) return;

  var variantRadios = infoContainer.querySelector('variant-radios');
  if (!variantRadios) return;

  var conditionParams = infoContainer.querySelector('.product-parameters--condition');

  if (conditionParams) {
    // Skip the JS move when the condition is already inside variant-radios.
    // The Liquid template (sections/main-product.liquid) now renders the
    // condition inline within `<variant-radios>` directly, so the original
    // post-load DOM move is no longer needed — and removing it eliminates
    // a noticeable layout shift on page load that was hurting CLS.
    // The `!contains` guard preserves backward compat for any template that
    // still has condition rendered as a separate sibling block.
    if (!variantRadios.contains(conditionParams)) {
      // Insert after color swatches, before the first non-color variant control
      var firstNonColor = Array.from(variantRadios.querySelectorAll('.product-form__controls'))
        .find(function (el) { return !el.classList.contains('product-form__controls--colors'); });

      if (firstNonColor) {
        variantRadios.insertBefore(conditionParams, firstNonColor);
      } else {
        variantRadios.appendChild(conditionParams);
      }
    }

    // Stop condition change events from bubbling into variant-radios'
    // onVariantChange handler — condition selection is cosmetic only.
    conditionParams.addEventListener('change', function (e) {
      e.stopPropagation();
    });
  }

  // Helper: is a fieldset visually hidden? Covers inline style="display:none"
  // (what the Liquid template sets on Rental Length) and any CSS display:none.
  function isHiddenFieldset(fs) {
    if (!fs || !fs.isConnected) return false;
    if (fs.style && fs.style.display === 'none') return true;
    var cs = window.getComputedStyle(fs);
    return cs.display === 'none' || cs.visibility === 'hidden';
  }

  // Helper: get all variant-option fieldsets (excludes cosmetic condition block)
  function getOptionFieldsets(root) {
    return Array.from(root.querySelectorAll('fieldset'))
      .filter(function (fs) { return !fs.closest('.product-parameters--condition'); });
  }

  // Helper: align hidden fieldsets so the current visible selections resolve to
  // an available variant. Runs BEFORE updateOptions() builds this.options.
  variantRadios.alignHiddenOptions = function () {
    var fieldsets = getOptionFieldsets(this);
    if (!fieldsets.length || !this.variantData) return;

    var hasHidden = fieldsets.some(isHiddenFieldset);
    if (!hasHidden) return; // Nothing to align

    // Current checked values for every tier
    var current = fieldsets.map(function (fs) {
      var checked = fs.querySelector(':checked');
      return checked ? checked.value : null;
    });

    // If the current full combo already points at an available variant, leave it alone
    var currentVariant = this.variantData.find(function (variant) {
      return fieldsets.every(function (fs, i) {
        return variant['option' + (i + 1)] === current[i];
      });
    });
    if (currentVariant && currentVariant.available) return;

    // Find an available variant whose VISIBLE tiers match the current selections;
    // hidden tiers are wildcards we're willing to adjust.
    var candidate = this.variantData.find(function (variant) {
      if (!variant.available) return false;
      return fieldsets.every(function (fs, i) {
        if (isHiddenFieldset(fs)) return true; // hidden tier is a wildcard
        return variant['option' + (i + 1)] === current[i];
      });
    });
    if (!candidate) return; // No available combo for visible selection — let base logic show unavailable

    // Update hidden fieldsets' checked radio to match the candidate
    fieldsets.forEach(function (fs, i) {
      if (!isHiddenFieldset(fs)) return;
      var desired = candidate['option' + (i + 1)];
      var radios = fs.querySelectorAll('input[type="radio"]');
      radios.forEach(function (r) { r.checked = (r.value === desired); });
    });
  };

  // Patch updateOptions — filters condition fieldsets out, aligns hidden tiers first.
  variantRadios.updateOptions = function () {
    this.alignHiddenOptions();
    var fieldsets = getOptionFieldsets(this);
    this.options = fieldsets.map(function (fieldset) {
      var checked = Array.from(fieldset.querySelectorAll('input')).find(function (r) { return r.checked; });
      return checked ? checked.value : null;
    });
  };

  // Patch updateVariantStatuses — hidden tiers are wildcards (don't constrain
  // downstream availability, don't get updated themselves).
  variantRadios.updateVariantStatuses = function () {
    var self = this;
    var inputWrappers = Array.from(this.querySelectorAll('.product-form__controls'))
      .filter(function (el) { return !el.closest('.product-parameters--condition'); });

    // Snapshot each tier's checked value and hidden state
    var tiers = inputWrappers.map(function (wrapper) {
      var checked = wrapper.querySelector(':checked');
      return {
        value: checked ? checked.value : null,
        hidden: isHiddenFieldset(wrapper.tagName === 'FIELDSET' ? wrapper : wrapper.closest('fieldset') || wrapper)
      };
    });

    inputWrappers.forEach(function (option, index) {
      if (index === 0) return;
      // Don't bother updating hidden tiers — they're auto-aligned, not user-facing
      if (tiers[index].hidden) return;

      var optionInputs = Array.from(option.querySelectorAll('input[type="radio"], option'));

      // A value is available if ANY variant is available that matches all
      // non-hidden upstream tiers' currently-selected values.
      var availableValues = self.variantData
        .filter(function (variant) {
          if (!variant.available) return false;
          for (var i = 0; i < index; i++) {
            if (tiers[i].hidden) continue; // wildcard
            if (variant['option' + (i + 1)] !== tiers[i].value) return false;
          }
          return true;
        })
        .map(function (variant) { return variant['option' + (index + 1)]; });

      self.setInputAvailability(optionInputs, availableValues);
    });
  };
})();
